import React from 'react'
import InstancesCatalogFilter from '../../__filter/_instancesCatalog/catalog__filter_instancesCatalog'
import EditableText from 'blocks.simple/editableText/editableText'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import styles from '../_instancesCatalog/catalog__template_instancesCatalog.jcss'
import { ItemData } from '../../../../core/models/Template'

export default {
    getMethod: 'getGrades',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noGrades'),
    emptyDescription: () => translate('noGradesDescription'),
    emptyIcon: 'not_allow',
    disableDrag: true,
    addItemButton: () => null,
    settingsPrefixes: 'grades',
    sortOptions: () => [
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: 'title', name: translate('byNameAsc') },
    ],
    headerFilters: (p_: {
        onAddFakeLine: (data?: { [index: string]: any } | null) => void
        fakeLine: string
        selectedItems: { id: number }[]
    }) => (
        <InstancesCatalogFilter
            onAdd={() => p_.onAddFakeLine({ title: '' })}
            title={translate('grades')}
            type="grade"
            onDelete={() => {
                const id = p_.selectedItems.map((selectedItem) => selectedItem.id)
                if (id.length > 0) {
                    api.send('deleteGrade', { id })
                }
                if (p_.fakeLine) {
                    p_.onAddFakeLine(null)
                }
            }}
            selectedItems={p_.selectedItems}
            {...p_}
        />
    ),
    getItemModel: (dataItem: ItemData, getSelected: (item: ItemData) => boolean) => {
        const item = { ...dataItem }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    getBackendModel: (item: { id: number }) => {
        return api.send('getGrade', { id: item.id }, { hideLoader: true })
    },
    tableWrapper: styles.tableWrapper,
    isEqual: (firstItem: ItemData, secondItem: ItemData) => firstItem.id === secondItem.id,
    onCreateListeners: [(cb: any, clearList: string[]) => api.addObserver('gradeCreated', cb, clearList)],
    onUpdateListeners: [(cb: any, clearList: string[]) => api.addObserver('gradeUpdated', cb, clearList)],
    onDeleteListeners: [(cb: any, clearList: string[]) => api.addObserver('gradeDeleted', cb, clearList)],
    isFolder: () => {},
    fields: () => [{ id: 'title', name: translate('name') }],
    init(callback: any) {
        //@ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    list: {
        title: (p_: { id: number; title: string }, active: boolean, listProps: { onAddFakeLine: () => void }) => (
            <EditableText
                id={p_.id}
                text={p_.title}
                onCreate={(title) => api.send('createGrade', { title })}
                onUpdate={(title, cb) => {
                    api.send('updateGrade', { title, id: p_.id }).then(cb)
                }}
                onSaveEmpty={function () {
                    listProps.onAddFakeLine()
                }}
            />
        ),
    },
    hideActiveRowColor: true,
    disableUpdateUserSettings: true,
    onDeleteListItem: (listItem: { id: number }) => {
        api.send('deleteGrade', { id: listItem.id })
    },
    fixedColWidth: true,
}
